import { Skeleton } from '@picsart/design-system/components/Skeleton';
import classNames from 'classnames';

import useStyles from './styles';

export default function PricingCardsSkeleton({ itemsCount }: { itemsCount: number }) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {Array.from({ length: itemsCount }).map((_, index) => (
        // eslint-disable-next-line react/jsx-key
        <Skeleton key={index} className={classNames(classes.card, classes.cardSkeleton)} />
      ))}
    </div>
  );
}
